export default __webpack_public_path__ + "static/media/Tiktok.0049bdc6.svg";